module.exports = __webpack_public_path__ + "img/i_images.63ef2f93.svg";